export default {
  name: 'Название',
  status: 'Статус',
  description: 'Описание',
  source: {
    type: 'Тип источника'
  },
  output: {
    type: 'Тип выхода'
  },
  pipeline: {
    name: 'Название пайплайна'
  },
  created_by: 'Автор',
  element_name: 'Название элемента',
  element_type: 'Тип элемента',
  access: 'Доступ',
  usage: 'Используется в дашбордах',
  list_type: 'Тип списка',
  list_last_update: 'Последнее обновление',
  'number of items': 'Количество элементов',
  ID: 'ID',
  image_1: 'Изображение 1',
  image_2: 'Изображение 2'
}
